export default __webpack_public_path__ + "static/media/foot3.ed447ab0.jpg";